import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IDispositivo,
  ICreateDispositivo,
  IListado,
  IQueryParam,
  IUpdateDispositivo,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class DispositivosService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<IDispositivo>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/dispositivos`, { params });
  }

  public crear(dato: ICreateDispositivo): Observable<IDispositivo> {
    return this.http.post(`${api}/dispositivos`, dato);
  }

  public listarPorId(id: string): Observable<IDispositivo> {
    return this.http.get(`${api}/dispositivos/${id}`);
  }

  public listarPorDeveui(deveui: string): Observable<IDispositivo> {
    return this.http.get(`${api}/dispositivos/deveui/${deveui}`);
  }

  public editar(
    id: string,
    dato: IUpdateDispositivo,
  ): Observable<IDispositivo> {
    return this.http.put(`${api}/dispositivos/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/dispositivos/${id}`);
  }
}
